import type { SVGProps } from 'react'
const SvgSyShieldDone = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M11.313 2.104 4.73 4.416A1.845 1.845 0 0 0 3.5 6.152v6.768c0 2.077.756 4.06 2.09 5.596.691.797 1.542 1.392 2.418 1.865v.002l3.564 1.922a.75.75 0 0 0 .713 0l3.557-1.922c.875-.473 1.726-1.071 2.416-1.867a8.53 8.53 0 0 0 2.086-5.592V6.152c0-.778-.496-1.479-1.23-1.736L12.53 2.104a1.84 1.84 0 0 0-1.219 0m.72 1.414h.002l6.582 2.314a.33.33 0 0 1 .227.32v6.772a7.03 7.03 0 0 1-1.719 4.61c-.532.613-1.23 1.114-1.996 1.529l-3.201 1.73-3.207-1.73c-.768-.415-1.466-.915-1.998-1.53v-.002A7.03 7.03 0 0 1 5 12.92V6.152c0-.147.088-.271.227-.32h.002l6.58-2.312a.34.34 0 0 1 .224-.002"
				clipRule="evenodd"
			/>
			<path
				d="M15.113 9.162a.75.75 0 0 0-.531.22l-3.37 3.368-1.358-1.363a.75.75 0 0 0-1.061 0 .75.75 0 0 0 0 1.06l1.89 1.893a.75.75 0 0 0 1.061.002l3.899-3.899a.75.75 0 0 0 0-1.06.75.75 0 0 0-.53-.22"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyShieldDone
